import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  LinearProgress,
  CircularProgress,
} from '@mui/material';
import RestoreIcon from '@mui/icons-material/Restore';

interface LoadingDialogProps {
  open: boolean;
  progress: number;
  title?: string;
  message?: string;
}

export default function LoadingDialog({
  open,
  progress,
  title = 'Restableciendo parámetros...',
  message = 'Por favor espera mientras se restablecen los valores predefinidos.'
}: LoadingDialogProps) {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: 24,
        }
      }}
    >
      <DialogContent>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          py: 3,
          px: 2,
        }}>
          {/* Icono animado */}
          <Box sx={{
            position: 'relative',
            display: 'inline-flex',
            mb: 3,
          }}>
            <CircularProgress
              size={80}
              thickness={3}
              variant="determinate"
              value={progress}
              sx={{
                color: 'warning.main',
              }}
            />
            <Box
              sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <RestoreIcon
                sx={{
                  fontSize: 40,
                  color: 'warning.main',
                  animation: 'spin 2s linear infinite',
                  '@keyframes spin': {
                    '0%': {
                      transform: 'rotate(0deg)',
                    },
                    '100%': {
                      transform: 'rotate(360deg)',
                    },
                  },
                }}
              />
            </Box>
          </Box>

          {/* Título */}
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              textAlign: 'center',
              mb: 1,
              color: 'text.primary',
            }}
          >
            {title}
          </Typography>

          {/* Mensaje */}
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              textAlign: 'center',
              mb: 3,
            }}
          >
            {message}
          </Typography>

          {/* Barra de progreso */}
          <Box sx={{ width: '100%', mb: 1 }}>
            <LinearProgress
              variant="determinate"
              value={progress}
              sx={{
                height: 8,
                borderRadius: 4,
                backgroundColor: 'grey.200',
                '& .MuiLinearProgress-bar': {
                  borderRadius: 4,
                  backgroundColor: 'warning.main',
                },
              }}
            />
          </Box>

          {/* Porcentaje */}
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: 'warning.main',
            }}
          >
            {progress}%
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
